/**
 * Squishy World — desktop menu hover enhancement
 * Opens top-level Dawn <details> menus on mouse hover while preserving
 * native click, keyboard, Escape and touch behaviour.
 */
(() => {
  const desktopHover = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
  const initialized = new WeakSet();
  const CLOSE_DELAY = 160;

  function initDesktopHoverMenus(root = document) {
    const menus = root.querySelectorAll(
      '.sw-header-nav > .list-menu--inline > li > header-menu > details'
    );

    menus.forEach((details) => {
      if (initialized.has(details)) return;
      initialized.add(details);

      let closeTimer;

      const closeOtherMenus = () => {
        const nav = details.closest('.sw-header-nav');
        if (!nav) return;

        nav.querySelectorAll(':scope > .list-menu--inline > li > header-menu > details[open]').forEach((other) => {
          if (other !== details) other.open = false;
        });
      };

      details.addEventListener('pointerenter', () => {
        if (!desktopHover.matches) return;
        window.clearTimeout(closeTimer);
        closeOtherMenus();
        details.open = true;
      });

      details.addEventListener('pointerleave', () => {
        if (!desktopHover.matches) return;
        window.clearTimeout(closeTimer);

        closeTimer = window.setTimeout(() => {
          if (details.matches(':hover')) return;
          if (details.contains(document.activeElement)) return;
          details.open = false;
        }, CLOSE_DELAY);
      });

      details.addEventListener('focusin', () => {
        window.clearTimeout(closeTimer);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initDesktopHoverMenus());
  } else {
    initDesktopHoverMenus();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initDesktopHoverMenus(event.target);
  });
})();
